import { jsx as z } from "react/jsx-runtime";
import { createContext as R, forwardRef as w, useContext as P, useRef as S, useMemo as k, useImperativeHandle as N, useState as V, useCallback as B } from "react";
import { e as D } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as g } from "./tw-cn-mXgPecoF.mjs";
import { c as E } from "./variance-DhhqoHkK.mjs";
const y = R(null), G = y.Provider, j = E(
  [
    "peer size-full appearance-none rounded-full cursor-pointer",
    "flex items-center justify-center",
    "bg-static-white border border-line-neutral-medium",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "checked:border-none disabled:cursor-not-allowed",
    "checked:bg-fill-primary-main checked:hover-never:bg-interaction-primary-presshover-strong3 checked:active:bg-interaction-primary-presshover-strong3",
    'checked:after:content-[""] checked:after:bg-static-white checked:after:rounded-full',
    "disabled:bg-fill-neutral-weak disabled:border-interaction-neutral-disable-main",
    "disabled:checked:bg-interaction-neutral-disable-main disabled:hover-never:checked:bg-interaction-neutral-disable-main",
    "disabled:hover-never:bg-fill-neutral-weak"
  ],
  {
    variants: {
      size: {
        medium: "size-24 checked:after:size-12",
        small: "size-20 checked:after:size-10"
      },
      pcSize: {
        medium: "pc:size-24 pc:checked:after:size-12",
        small: "pc:size-20 pc:checked:after:size-10"
      }
    }
  }
), K = w((c, b) => {
  const { className: l, style: p, value: d, type: u = "radio", size: f, onChange: o, ...r } = c, e = P(y), i = S(null), n = k(() => {
    var a, t;
    return typeof (e == null ? void 0 : e.size) == "string" ? {
      mobile: e.size,
      pc: e.size
    } : { mobile: (a = e == null ? void 0 : e.size) == null ? void 0 : a.mobile, pc: (t = e == null ? void 0 : e.size) == null ? void 0 : t.pc };
  }, [e == null ? void 0 : e.size]), v = D({
    property: f,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: {
      mobile: n.mobile || "small",
      pc: n.pc || "medium"
    }
  }), m = j({ ...v });
  N(b, () => ({
    focus: (a) => {
      var t;
      (t = i.current) == null || t.focus(a);
    },
    blur: () => {
      var a;
      (a = i.current) == null || a.blur();
    },
    input: i.current,
    nativeElement: i.current
  }));
  const h = (a) => {
    if (r.disabled)
      return;
    const t = {
      target: {
        ...c,
        type: u,
        checked: a.target.checked
      },
      stopPropagation() {
        a.stopPropagation();
      },
      preventDefault() {
        a.preventDefault();
      },
      nativeEvent: a.nativeEvent
    };
    o == null || o(t), e == null || e.onChange(t);
  }, s = { ...r };
  return e && (s.name = e.name ?? r.name, s.checked = d === e.value, s.disabled = r.disabled ?? e.disabled), /* @__PURE__ */ z(
    "input",
    {
      ...s,
      className: g(m, l),
      onChange: h,
      ref: i,
      style: p,
      type: u,
      value: d
    }
  );
});
K.displayName = "NDS.RadioButton";
const q = (c) => {
  const {
    id: b,
    name: l,
    className: p,
    children: d,
    value: u,
    defaultValue: f,
    disabled: o,
    size: r,
    style: e,
    onChange: i
  } = c, [n, v] = V(u ?? f), m = B(
    (s) => {
      const a = n, t = s.target.value;
      "value" in c || v(t), t !== a && (i == null || i(s));
    },
    [n, c, i]
  ), h = k(
    () => ({ onChange: m, value: n, disabled: o, name: l, size: r }),
    [m, n, o, l, r]
  );
  return /* @__PURE__ */ z("div", { className: g(p), id: b, style: e, children: /* @__PURE__ */ z(G, { value: h, children: d }) });
};
export {
  q as R,
  K as a
};
